import { nextTick } from 'vue';
import { mapGetters } from 'vuex';

const DEFAULT_SUGGESTIONS = [
    { display: 'Is this home still available?', value: 'Is this home still available? ' },
    { display: "I'd like more details about...", value: "I'd like more details about " },
];

export default {
    name: 'mvtCommentSuggest',
    props: {
        modelValue: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            default: 'commentSuggest',
        },
        name: {
            type: String,
            default: 'comment',
        },
        maxlength: {
            type: [String, Number],
            default: 4000,
        },
        validate: {
            type: String,
            default: 'required|comment',
        },
    },
    emits: ['update:modelValue'],
    computed: {
        ...mapGetters('glb', ['getSplit']),
        placeholder() {
            if (this.getSplit('movoto-comment-CW-3773', 'on1')) {
                return 'Write my own question...';
            }
            return 'Write a question.';
        },
        suggestions() {
            if (this.getSplit('movoto-comment-CW-3773', 'on1')) {
                return DEFAULT_SUGGESTIONS;
            }
            return [];
        },
        innerValue: {
            get() {
                return this.modelValue ?? '';
            },
            set(val) {
                this.$emit('update:modelValue', val);
            },
        },
        visibleSuggestions() {
            if (this.innerValue) {
                return [];
            }
            const list = Array.isArray(this.suggestions) ? this.suggestions : [];
            return list.map((item, index) => {
                if (typeof item === 'string') {
                    return { display: item, value: item, index };
                }
                const display = String(item?.display ?? '');
                const value = String(item?.value ?? display);
                return { display, value, index };
            });
        },
    },
    methods: {
        onPillClick(item) {
            this.innerValue = item.value;
            nextTick(() => {
                this.$refs.textarea?.focus();
            });
        },
    },
};
